export const tokenUtils = {
  // Check if token exists
  hasToken: () => {
    return localStorage.getItem('token') !== null;
  },

  // Get token
  getToken: () => {
    return localStorage.getItem('token');
  },

  // Set token
  setToken: (token) => {
    localStorage.setItem('token', token);
  },

  // Remove token and related data
  removeToken: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
  },

  // Check if token is expired (only called when needed)
  isTokenExpired: () => {
    const token = localStorage.getItem('token');
    if (!token) return true;

    try {
      const tokenPayload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return tokenPayload.exp < currentTime;
    } catch (error) {

      return true;
    }
  },

  // Get user info from token
  getUserFromToken: () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
      const tokenPayload = JSON.parse(atob(token.split('.')[1]));
      return {
        id: tokenPayload.sub,
        name: tokenPayload.name,
        email: tokenPayload.email,
        // Add other fields as needed
      };
    } catch (error) {

      return null;
    }
  }
};